<template>
  <div class="pdfimport">
    <div class="row form-group">
      <div class="col-xs-12">
        <label for="pdf_file" class="control-label">Anexos (PDF)</label>
        <input
          id="pdf_file"
          type="file"
          ref="pdf_file"
          name="pdf_file"
          accept="application/pdf"
          class="form-control"
          @change="loadPDF"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      file: ''
    }
  },
  methods: {
    loadPDF(e) {
      const pdf_file = e.target.files[0]
      this.file = pdf_file
    },
    clean() {
      this.file = ''
      this.$refs.pdf_file.value = ''
    }
  },
  watch: {
    file(newValue) {
      this.$emit('loadFile', newValue)
    }
  }
}
</script>

<style scoped>
.trash {
  color: #ff3860;
}
</style>



// WEBPACK FOOTER //
// src/components/common/PDFImport.vue